module.exports = __webpack_public_path__ + "img/icon-upload-image-coming-soon.4b06223f.jpg";